export const ru = {
  ra: {
    action: {
      add_filter: 'Добавить фильтр',
      add: 'Добавить',
      back: 'Назад',
      bulk_actions: 'Выбрано: %{smart_count}',
      cancel: 'Отмена',
      clear_input_value: 'Очистить',
      clone: 'Клонировать',
      confirm: 'Подтвердить',
      create: 'Создать',
      delete: 'Удалить',
      edit: 'Редактировать',
      export: 'Экспорт',
      list: 'Список',
      refresh: 'Обновить',
      remove_filter: 'Удалить фильтр',
      remove: 'Удалить',
      save: 'Сохранить',
      search: 'Поиск',
      show: 'Показать',
      sort: 'Сортировка',
      undo: 'Отменить',
      unselect: 'Снять выделение',
      expand: 'Развернуть',
      close: 'Закрыть',
      open_menu: 'Открыть меню',
      close_menu: 'Закрыть меню',
    },
    boolean: {
      true: 'Да',
      false: 'Нет',
      null: ' ',
    },
    page: {
      create: 'Создать %{name}',
      dashboard: 'Панель управления',
      edit: '%{name} #%{id}',
      error: 'Что-то пошло не так',
      list: '%{name}',
      loading: 'Загрузка',
      not_found: 'Не найдено',
      show: '%{name} #%{id}',
      empty: 'Нет %{name}.',
      invite: 'Хотите добавить?',
    },
    input: {
      file: {
        upload_several: 'Перетащите файлы для загрузки или нажмите для выбора.',
        upload_single: 'Перетащите файл для загрузки или нажмите для выбора.',
      },
      image: {
        upload_several: 'Перетащите изображения для загрузки или нажмите для выбора.',
        upload_single: 'Перетащите изображение для загрузки или нажмите для выбора.',
      },
      references: {
        all_missing: 'Невозможно найти связанные данные.',
        many_missing: 'По крайней мере одна из связанных ссылок больше не доступна.',
        single_missing: 'Связанная ссылка больше не доступна.',
      },
      password: {
        toggle_visible: 'Скрыть пароль',
        toggle_hidden: 'Показать пароль',
      },
    },
    message: {
      about: 'О программе',
      are_you_sure: 'Вы уверены?',
      bulk_delete_content:
        'Вы уверены, что хотите удалить %{name}? |||| Вы уверены, что хотите удалить %{smart_count} элементов?',
      bulk_delete_title: 'Удалить %{name} |||| Удалить %{smart_count} %{name}',
      delete_content: 'Вы уверены, что хотите удалить этот элемент?',
      delete_title: 'Удалить %{name} #%{id}',
      details: 'Детали',
      error: 'Произошла ошибка и ваш запрос не может быть выполнен.',
      invalid_form: 'Форма заполнена неверно. Пожалуйста, проверьте ошибки',
      loading: 'Страница загружается, пожалуйста подождите',
      no: 'Нет',
      not_found: 'Вы ввели неверный URL или перешли по неверной ссылке.',
      yes: 'Да',
      unsaved_changes: 'Некоторые изменения не сохранены. Вы уверены, что хотите их проигнорировать?',
    },
    navigation: {
      no_results: 'Результатов не найдено',
      no_more_results: 'Страница %{page} находится за пределами. Попробуйте предыдущую страницу.',
      page_out_of_boundaries: 'Номер страницы %{page} за пределами',
      page_out_from_end: 'Невозможно перейти после последней страницы',
      page_out_from_begin: 'Невозможно перейти до страницы 1',
      page_range_info: '%{offsetBegin}-%{offsetEnd} из %{total}',
      page_rows_per_page: 'Строк на странице:',
      next: 'Следующая',
      prev: 'Предыдущая',
    },
    auth: {
      auth_check_error: 'Пожалуйста, войдите чтобы продолжить',
      user_menu: 'Профиль',
      username: 'Имя пользователя',
      password: 'Пароль',
      sign_in: 'Войти',
      sign_in_error: 'Ошибка аутентификации, попробуйте еще раз',
      logout: 'Выйти',
    },
    notification: {
      updated: 'Элемент обновлен |||| %{smart_count} элементов обновлено',
      created: 'Элемент создан',
      deleted: 'Элемент удален |||| %{smart_count} элементов удалено',
      bad_item: 'Неверный элемент',
      item_doesnt_exist: 'Элемент не существует',
      http_error: 'Ошибка связи с сервером',
      data_provider_error: 'Ошибка dataProvider. Проверьте консоль для деталей.',
      i18n_error: 'Невозможно загрузить переводы для указанного языка',
      canceled: 'Действие отменено',
      logged_out: 'Ваша сессия завершена, пожалуйста, войдите снова.',
    },
    validation: {
      required: 'Обязательное поле',
      minLength: 'Минимум %{min} символов',
      maxLength: 'Максимум %{max} символов',
      minValue: 'Минимум %{min}',
      maxValue: 'Максимум %{max}',
      number: 'Должно быть числом',
      email: 'Должен быть корректный email',
      oneOf: 'Должно быть одним из: %{options}',
      regex: 'Должно соответствовать формату (regexp): %{pattern}',
    },
  },
  resources: {
    users: {
      name: 'Пользователь |||| Пользователи',
      fields: {
        id: 'ID',
        username: 'Имя пользователя',
        first_name: 'Имя',
        last_name: 'Фамилия',
        language_code: 'Язык',
        is_blacklisted: 'В бан-листе',
        total_bets: 'Всего ставок',
        total_wagered: 'Всего поставлено',
        total_won: 'Всего выиграно',
        created_at: 'Зарегистрирован',
        last_active: 'Последняя активность',
      },
      actions: {
        ban: 'Забанить',
        unban: 'Разбанить',
      },
    },
    transactions: {
      name: 'Транзакция |||| Транзакции',
      fields: {
        id: 'ID',
        user_id: 'ID пользователя',
        event_id: 'ID события',
        amount: 'Сумма',
        currency: 'Валюта',
        tx_type: 'Тип',
        tx_hash: 'Хеш транзакции',
        status: 'Статус',
        created_at: 'Создана',
        completed_at: 'Завершена',
        error_message: 'Сообщение об ошибке',
      },
      types: {
        prize_payout: 'Выплата приза',
        escrow_payment: 'Эскроу платеж',
        escrow_refund: 'Возврат эскроу',
      },
      status: {
        PENDING: 'Ожидание',
        COMPLETED: 'Завершена',
        FAILED: 'Ошибка',
        REFUNDED: 'Возвращена',
      },
      actions: {
        retry: 'Повторить платеж',
        refund: 'Вернуть средства',
      },
    },
    'statistics/users': {
      name: 'Статистика пользователей',
      fields: {
        user_id: 'ID пользователя',
        username: 'Имя пользователя',
        total_events: 'Всего событий',
        total_bets: 'Всего ставок',
        total_wagered: 'Всего поставлено',
        total_won: 'Всего выиграно',
        win_rate: 'Процент побед',
        avg_bet: 'Средняя ставка',
        biggest_win: 'Самый большой выигрыш',
      },
    },
    'statistics/owners': {
      name: 'Статистика владельцев',
      fields: {
        owner_id: 'ID владельца',
        username: 'Имя пользователя',
        total_events_created: 'Создано событий',
        total_participants: 'Всего участников',
        total_prize_pool: 'Общий призовой фонд',
        avg_participants_per_event: 'Средне участников',
        active_events: 'Активные события',
      },
    },
    'support/tickets': {
      name: 'Тикет |||| Тикеты поддержки',
      fields: {
        id: 'ID тикета',
        user_id: 'ID пользователя',
        subject: 'Тема',
        category: 'Категория',
        priority: 'Приоритет',
        status: 'Статус',
        assigned_to: 'Назначен',
        created_at: 'Создан',
        updated_at: 'Обновлен',
        resolved_at: 'Решен',
      },
      categories: {
        technical: 'Технические',
        payment: 'Платежи',
        account: 'Аккаунт',
        event: 'События',
        other: 'Прочее',
      },
      priorities: {
        low: 'Низкий',
        medium: 'Средний',
        high: 'Высокий',
        urgent: 'Срочно',
      },
      status: {
        OPEN: 'Открыт',
        IN_PROGRESS: 'В работе',
        RESOLVED: 'Решен',
        CLOSED: 'Закрыт',
      },
      actions: {
        assign: 'Назначить мне',
        reply: 'Ответить',
        resolve: 'Решить',
        close: 'Закрыть',
      },
    },
    'admin-users': {
      name: 'Администратор |||| Администраторы',
      fields: {
        id: 'ID',
        username: 'Имя пользователя',
        email: 'Email',
        role: 'Роль',
        role_id: 'Роль',
        is_active: 'Активен',
        last_login: 'Последний вход',
        created_at: 'Создан',
      },
      actions: {
        reset_password: 'Сбросить пароль',
        deactivate: 'Деактивировать',
        activate: 'Активировать',
      },
    },
    roles: {
      name: 'Роль |||| Роли',
      fields: {
        id: 'ID',
        name: 'Название',
        description: 'Описание',
        permissions: 'Разрешения',
        created_at: 'Создана',
        updated_at: 'Обновлена',
      },
      permissions: {
        users_view: 'Просмотр пользователей',
        users_edit: 'Редактирование пользователей',
        users_delete: 'Удаление пользователей',
        transactions_view: 'Просмотр транзакций',
        transactions_manage: 'Управление транзакциями',
        support_view: 'Просмотр тикетов',
        support_manage: 'Управление тикетами',
        admin_users_view: 'Просмотр администраторов',
        admin_users_manage: 'Управление администраторами',
        roles_view: 'Просмотр ролей',
        roles_manage: 'Управление ролями',
        settings_view: 'Просмотр настроек',
        settings_edit: 'Редактирование настроек',
        audit_view: 'Просмотр журнала',
        statistics_view: 'Просмотр статистики',
      },
    },
    settings: {
      name: 'Настройка |||| Настройки',
      fields: {
        key: 'Ключ настройки',
        value: 'Значение',
        description: 'Описание',
        updated_at: 'Последнее обновление',
        updated_by: 'Обновил',
      },
      keys: {
        maintenance_mode: 'Режим обслуживания',
        api_rate_limit: 'Лимит API запросов',
        max_file_size: 'Макс. размер файла',
        session_timeout: 'Время сессии',
        email_notifications: 'Email уведомления',
        xrocket_api_enabled: 'xRocket API включен',
      },
    },
    'audit-log': {
      name: 'Запись журнала |||| Журнал аудита',
      fields: {
        id: 'ID',
        admin_user_id: 'Администратор',
        action: 'Действие',
        resource: 'Ресурс',
        resource_id: 'ID ресурса',
        changes: 'Изменения',
        ip_address: 'IP адрес',
        user_agent: 'User Agent',
        created_at: 'Время',
      },
      actions: {
        CREATE: 'Создано',
        UPDATE: 'Обновлено',
        DELETE: 'Удалено',
        LOGIN: 'Вход',
        LOGOUT: 'Выход',
        BAN_USER: 'Пользователь забанен',
        UNBAN_USER: 'Пользователь разбанен',
        RESET_PASSWORD: 'Сброс пароля',
      },
    },
  },
  custom: {
    dashboard: {
      title: 'Панель управления',
      welcome: 'Добро пожаловать в админку казино',
      metrics: {
        total_users: 'Всего пользователей',
        active_users: 'Активные пользователи',
        total_transactions: 'Всего транзакций',
        revenue_24h: 'Доход (24ч)',
        revenue_7d: 'Доход (7д)',
        revenue_30d: 'Доход (30д)',
      },
      charts: {
        volume_over_time: 'Объем транзакций во времени',
        token_distribution: 'Распределение токенов',
        user_activity: 'Активность пользователей',
        recent_activity: 'Недавняя активность',
      },
    },
    notifications: {
      password_reset_success: 'Пароль успешно сброшен',
      password_reset_error: 'Не удалось сбросить пароль',
      user_banned: 'Пользователь успешно забанен',
      user_unbanned: 'Пользователь успешно разбанен',
      transaction_retried: 'Повтор транзакции инициирован',
      transaction_refunded: 'Возврат успешно выполнен',
      ticket_assigned: 'Тикет успешно назначен',
      ticket_resolved: 'Тикет успешно решен',
      settings_updated: 'Настройки успешно обновлены',
    },
    errors: {
      database_error: 'Ошибка базы данных. Пожалуйста, попробуйте еще раз.',
      network_error: 'Ошибка сети. Проверьте соединение.',
      unauthorized: 'У вас нет прав для этого действия.',
      not_found: 'Запрашиваемый ресурс не найден.',
      validation_error: 'Проверьте введенные данные и попробуйте еще раз.',
      server_error: 'Ошибка сервера. Обратитесь в поддержку.',
    },
  },
};
